function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21.1729,
  cy: 21.4487,
  r: 20.75,
  fill: "#93C48B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.7384 17.8826V17.3826H22.2384H19.735H19.235V17.8826V19.8691H17.2485H16.7485V20.3691V22.8724V23.3724H17.2485H19.235V25.3592V25.8592H19.735H22.2384H22.7384V25.3592V23.3724H24.7251H25.2251V22.8724V20.3691V19.8691H24.7251H22.7384V17.8826Z",
  stroke: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 11.3838,
  y: 14.55,
  width: 19.3125,
  height: 13.8374,
  stroke: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 16.915,
  y: 11.4688,
  width: 7.90625,
  height: 3.09375,
  stroke: "white"
});

var SvgMedical = function SvgMedical(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedical, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medical.0e853b80.svg";
export { ForwardRef as ReactComponent };